import React from 'react'
import {
    BackButton,
    BlocFraisDeNotaire,
    BlocIntField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
} from '../ImportAll'

export default function Vue5() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Montant de l’opération"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={20} time={3} />
            </div>

            {/* SI PROJET TYPE SUR ANCIEN */}
            <Conditionnal
                linked_data_id="prj_type"
                isEqualTo
                targetDataValueCompare="LOGEMENT_ANCIEN"
            >
                <div className="Container">
                    <BlocIntField
                        key="key16"
                        nbcolumn={1}
                        linked_data_id="prj_montant_achat"
                        symbole=" €"
                        label="Prix d’achat"
                        placeholder="Ex : 10 000 €"
                        infobulle="Indiquez ici le prix TTC sauf si la TVA n’est pas à votre charge. Dans ce dernier car, veuillez indiquer le prix HT et ajuster manuellement les frais de notaire."
                        limit={1000000000}
                        messageErreur="Le montant du projet est trop élevé."
                    />
                    <Conditionnal
                        linked_data_id="prj_usage"
                        isEqualTo
                        targetDataValueCompare="LOCATIF"
                    >
                        <BlocIntField
                            key="key20"
                            nbcolumn={1}
                            linked_data_id="prj_futur_loyer_estim"
                            symbole=" €"
                            label="Futur loyer mensuel perçu estimé pour ce bien (charge comprise)"
                            placeholder="Ex : 450 €"
                        />
                    </Conditionnal>
                    <BlocIntField
                        key="key17"
                        nbcolumn={1}
                        linked_data_id="prj_montant_frais_agence"
                        symbole=" €"
                        label="Frais d’agence immobilière"
                        placeholder="Ex : 10 000 €"
                    />
                    <BlocIntField
                        key="key18"
                        nbcolumn={1}
                        linked_data_id="prj_montant_travaux"
                        symbole=" €"
                        label="Montant des travaux"
                        placeholder="Ex : 10 000 €"
                    />
                    <BlocIntField
                        key="key19"
                        nbcolumn={1}
                        linked_data_id="prj_montant_frais_divers"
                        symbole=" €"
                        label="Frais divers"
                        placeholder="Ex : 10 000 €"
                        infobulle="Ex: Cuisine, aménagement, etc."
                    />

                    <BlocFraisDeNotaire
                        key="key21"
                        linked_data_id="prj_montant_frais_notaire"
                        infobulle="Si vous connaissez les frais de notaire, indiquez-les. Sinon, ils seront calculés automatiquement."
                    />
                </div>

                {/* affichage bouton suivant si prix achat rempli et si loyer remplis dans le cas d'un locatif */}
                <Conditionnal linked_data_id="prj_montant_achat" isNotEmpty>
                    <Conditionnal
                        linked_data_id="prj_montant_achat_validated"
                        isEqualTo
                        targetDataValueCompare={true}
                    >
                        <Conditionnal
                            linked_data_id="prj_usage"
                            isEqualTo
                            targetDataValueCompare="LOCATIF"
                        >
                            <Conditionnal
                                linked_data_id="prj_futur_loyer_estim"
                                isNotEmpty
                            >
                                <div className="SubmitButtonContainer">
                                    {' '}
                                    <Button text="Suivant" targetView={6} />{' '}
                                </div>
                            </Conditionnal>
                        </Conditionnal>
                        <Conditionnal
                            linked_data_id="prj_usage"
                            isNotEqualTo
                            targetDataValueCompare="LOCATIF"
                        >
                            <div className="SubmitButtonContainer">
                                {' '}
                                <Button text="Suivant" targetView={6} />{' '}
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>

            {/* SI PROJET TYPE SUR NEUF */}
            <Conditionnal
                linked_data_id="prj_type"
                isEqualTo
                targetDataValueCompare="LOGEMENT_NEUF"
            >
                <div className="Container">
                    <BlocIntField
                        key="key22"
                        nbcolumn={1}
                        linked_data_id="prj_montant_achat"
                        symbole=" €"
                        label="Prix d’achat"
                        placeholder="Ex : 10 000 €"
                        infobulle="Indiquez ici le prix TTC sauf si la TVA n’est pas à votre charge. Dans ce dernier car, veuillez indiquer le prix HT et ajuster manuellement les frais de notaire."
                        limit={1000000000}
                        messageErreur="Le montant du projet est trop élevé."
                    />
                    <Conditionnal
                        linked_data_id="tech_source_neuf"
                        isNotEqualTo
                        targetDataValueCompare={true}
                    >
                        <BlocIntField
                            key="key23"
                            nbcolumn={1}
                            linked_data_id="prj_montant_frais_agence"
                            symbole=" €"
                            label="Frais d’agence immobilière"
                            placeholder="Ex : 10 000 €"
                        />
                    </Conditionnal>
                    <BlocIntField
                        key="key24"
                        nbcolumn={1}
                        linked_data_id="prj_montant_frais_divers"
                        symbole=" €"
                        label="Frais divers"
                        placeholder="Ex : 10 000 €"
                        infobulle="Ex: Cuisine, aménagement, etc."
                    />
                    <Conditionnal
                        linked_data_id="prj_usage"
                        isEqualTo
                        targetDataValueCompare="LOCATIF"
                    >
                        <BlocIntField
                            key="key25"
                            nbcolumn={1}
                            linked_data_id="prj_futur_loyer_estim"
                            symbole=" €"
                            label="Futur loyer mensuel perçu estimé pour ce bien (charge comprise)"
                            placeholder="Ex : 450 €"
                        />
                    </Conditionnal>
                    <BlocFraisDeNotaire
                        key="key26"
                        linked_data_id="prj_montant_frais_notaire"
                        infobulle="Si vous connaissez les frais de notaire, indiquez-les. Sinon, ils seront calculés automatiquement."
                    />
                </div>

                {/* affichage bouton suivant si prix achat rempli et si loyer remplis dans le cas d'un locatif*/}
                <Conditionnal linked_data_id="prj_montant_achat" isNotEmpty>
                    <Conditionnal
                        linked_data_id="prj_montant_achat_validated"
                        isEqualTo
                        targetDataValueCompare={true}
                    >
                        <Conditionnal
                            linked_data_id="prj_usage"
                            isEqualTo
                            targetDataValueCompare="LOCATIF"
                        >
                            <Conditionnal
                                linked_data_id="prj_futur_loyer_estim"
                                isNotEmpty
                            >
                                <div className="SubmitButtonContainer">
                                    {' '}
                                    <Button text="Suivant" targetView={6} />{' '}
                                </div>
                            </Conditionnal>
                        </Conditionnal>
                        <Conditionnal
                            linked_data_id="prj_usage"
                            isNotEqualTo
                            targetDataValueCompare="LOCATIF"
                        >
                            <div className="SubmitButtonContainer">
                                {' '}
                                <Button text="Suivant" targetView={6} />{' '}
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>

            {/* SI PROJET TYPE SUR TERRAIN/CONSTRUCTION */}
            <Conditionnal
                linked_data_id="prj_type"
                isEqualTo
                targetDataValueCompare="TERRAIN_ET_CONSTRUCTION"
            >
                <div className="Container">
                    <BlocIntField
                        key="key27"
                        nbcolumn={1}
                        linked_data_id="prj_montant_terrain"
                        symbole=" €"
                        label="Prix du terrain"
                        placeholder="Ex : 10 000 €"
                        limit={1000000000}
                        messageErreur="Le montant du projet est trop élevé."
                    />
                    <BlocIntField
                        key="key28"
                        nbcolumn={1}
                        linked_data_id="prj_montant_construction"
                        symbole=" €"
                        label="Prix de la construction"
                        placeholder="Ex : 10 000 €"
                    />
                    <Conditionnal
                        linked_data_id="tech_source_neuf"
                        isNotEqualTo
                        targetDataValueCompare={true}
                    >
                        <BlocIntField
                            key="key29"
                            nbcolumn={1}
                            linked_data_id="prj_montant_frais_agence"
                            symbole=" €"
                            label="Frais d’agence immobilière"
                            placeholder="Ex : 10 000 €"
                        />
                    </Conditionnal>
                    <BlocIntField
                        key="key30"
                        nbcolumn={1}
                        linked_data_id="prj_montant_frais_divers"
                        symbole=" €"
                        label="Frais divers"
                        placeholder="Ex : 10 000 €"
                        infobulle="Ex: Cuisine, aménagement, etc."
                    />
                    <Conditionnal
                        linked_data_id="prj_usage"
                        isEqualTo
                        targetDataValueCompare="LOCATIF"
                    >
                        <BlocIntField
                            key="key31"
                            nbcolumn={1}
                            linked_data_id="prj_futur_loyer_estim"
                            symbole=" €"
                            label="Futur loyer mensuel perçu estimé pour ce bien (charge comprise)"
                            placeholder="Ex : 450 €"
                        />
                    </Conditionnal>
                    <BlocFraisDeNotaire
                        key="key32"
                        linked_data_id="prj_montant_frais_notaire"
                        infobulle="Si vous connaissez les frais de notaire, indiquez-les. Sinon, ils seront calculés automatiquement."
                    />
                </div>

                {/* affichage bouton suivant si prix terrain / prix construction / les deux remplies et si loyer remplis dans le cas d'un locatif*/}
                <Conditionnal linked_data_id="prj_montant_terrain" isNotEmpty>
                    <Conditionnal
                        linked_data_id="prj_montant_terrain_validated"
                        isEqualTo
                        targetDataValueCompare={true}
                    >
                        <Conditionnal
                            linked_data_id="prj_montant_construction"
                            isEmpty
                        >
                            <Conditionnal
                                linked_data_id="prj_usage"
                                isEqualTo
                                targetDataValueCompare="LOCATIF"
                            >
                                <Conditionnal
                                    linked_data_id="prj_futur_loyer_estim"
                                    isNotEmpty
                                >
                                    <div className="SubmitButtonContainer">
                                        {' '}
                                        <Button
                                            text="Suivant"
                                            targetView={6}
                                        />{' '}
                                    </div>
                                </Conditionnal>
                            </Conditionnal>
                            <Conditionnal
                                linked_data_id="prj_usage"
                                isNotEqualTo
                                targetDataValueCompare="LOCATIF"
                            >
                                <div className="SubmitButtonContainer">
                                    {' '}
                                    <Button text="Suivant" targetView={6} />{' '}
                                </div>
                            </Conditionnal>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>

                <Conditionnal linked_data_id="prj_montant_terrain" isEmpty>
                    <Conditionnal
                        linked_data_id="prj_montant_terrain_validated"
                        isEqualTo
                        targetDataValueCompare={true}
                    >
                        <Conditionnal
                            linked_data_id="prj_montant_construction"
                            isNotEmpty
                        >
                            <Conditionnal
                                linked_data_id="prj_usage"
                                isEqualTo
                                targetDataValueCompare="LOCATIF"
                            >
                                <Conditionnal
                                    linked_data_id="prj_futur_loyer_estim"
                                    isNotEmpty
                                >
                                    <div className="SubmitButtonContainer">
                                        {' '}
                                        <Button
                                            text="Suivant"
                                            targetView={6}
                                        />{' '}
                                    </div>
                                </Conditionnal>
                            </Conditionnal>
                            <Conditionnal
                                linked_data_id="prj_usage"
                                isNotEqualTo
                                targetDataValueCompare="LOCATIF"
                            >
                                <div className="SubmitButtonContainer">
                                    {' '}
                                    <Button text="Suivant" targetView={6} />{' '}
                                </div>
                            </Conditionnal>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>

                <Conditionnal linked_data_id="prj_montant_terrain" isNotEmpty>
                    <Conditionnal
                        linked_data_id="prj_montant_terrain_validated"
                        isEqualTo
                        targetDataValueCompare={true}
                    >
                        <Conditionnal
                            linked_data_id="prj_montant_construction"
                            isNotEmpty
                        >
                            <Conditionnal
                                linked_data_id="prj_usage"
                                isEqualTo
                                targetDataValueCompare="LOCATIF"
                            >
                                <Conditionnal
                                    linked_data_id="prj_futur_loyer_estim"
                                    isNotEmpty
                                >
                                    <div className="SubmitButtonContainer">
                                        {' '}
                                        <Button
                                            text="Suivant"
                                            targetView={6}
                                        />{' '}
                                    </div>
                                </Conditionnal>
                            </Conditionnal>
                            <Conditionnal
                                linked_data_id="prj_usage"
                                isNotEqualTo
                                targetDataValueCompare="LOCATIF"
                            >
                                <div className="SubmitButtonContainer">
                                    {' '}
                                    <Button text="Suivant" targetView={6} />{' '}
                                </div>
                            </Conditionnal>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>

            {/* SI PROJET TYPE SUR RENEGO  NORMALEMENT PLUS UTILISé */}
            <Conditionnal
                linked_data_id="prj_type"
                isEqualTo
                targetDataValueCompare="RENEGOCIATION"
            >
                <div className="Container">
                    <BlocIntField
                        key="key33"
                        nbcolumn={1}
                        linked_data_id="prj_montant_achat"
                        symbole=" €"
                        label="Prix d’achat"
                        placeholder="Ex : 10 000 €"
                        infobulle="Indiquez ici le prix TTC sauf si la TVA n’est pas à votre charge. Dans ce dernier car, veuillez indiquer le prix HT et ajuster manuellement les frais de notaire."
                        limit={1000000000}
                        messageErreur="Le montant du projet est trop élevé."
                    />
                    <BlocIntField
                        key="key34"
                        nbcolumn={1}
                        linked_data_id="prj_montant_frais_divers"
                        symbole=" €"
                        label="Frais divers"
                        placeholder="Ex : 10 000 €"
                        infobulle="Ex: Cuisine, aménagement, etc."
                    />
                    <Conditionnal
                        linked_data_id="prj_usage"
                        isEqualTo
                        targetDataValueCompare="LOCATIF"
                    >
                        <BlocIntField
                            key="key35"
                            nbcolumn={1}
                            linked_data_id="prj_futur_loyer_estim"
                            symbole=" €"
                            label="Futur loyer mensuel perçu estimé pour ce bien (charge comprise)"
                            placeholder="Ex : 450 €"
                        />
                    </Conditionnal>
                </div>

                <Conditionnal linked_data_id="prj_montant_achat" isNotEmpty>
                    <Conditionnal
                        linked_data_id="prj_montant_achat_validated"
                        isEqualTo
                        targetDataValueCompare={true}
                    >
                        <Conditionnal
                            linked_data_id="prj_usage"
                            isEqualTo
                            targetDataValueCompare="LOCATIF"
                        >
                            <Conditionnal
                                linked_data_id="prj_futur_loyer_estim"
                                isNotEmpty
                            >
                                <div className="SubmitButtonContainer">
                                    {' '}
                                    <Button text="Suivant" targetView={6} />{' '}
                                </div>
                            </Conditionnal>
                        </Conditionnal>
                        <Conditionnal
                            linked_data_id="prj_usage"
                            isNotEqualTo
                            targetDataValueCompare="LOCATIF"
                        >
                            <div className="SubmitButtonContainer">
                                {' '}
                                <Button text="Suivant" targetView={6} />{' '}
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>

            {/* SI PROJET TYPE SUR TRAVAUX */}
            <Conditionnal
                linked_data_id="prj_type"
                isEqualTo
                targetDataValueCompare="TRAVAUX"
            >
                <div className="Container">
                    <BlocIntField
                        key="key36"
                        nbcolumn={1}
                        linked_data_id="prj_montant_travaux"
                        symbole=" €"
                        label="Montant des travaux"
                        placeholder="Ex : 10 000 €"
                    />
                    <BlocIntField
                        key="key37"
                        nbcolumn={1}
                        linked_data_id="prj_montant_frais_divers"
                        symbole=" €"
                        label="Frais divers"
                        placeholder="Ex : 10 000 €"
                        infobulle="Ex: Cuisine, aménagement, etc."
                    />
                    <Conditionnal
                        linked_data_id="prj_usage"
                        isEqualTo
                        targetDataValueCompare="LOCATIF"
                    >
                        <BlocIntField
                            key="key38"
                            nbcolumn={1}
                            linked_data_id="prj_futur_loyer_estim"
                            symbole=" €"
                            label="Futur loyer mensuel perçu estimé pour ce bien (charge comprise)"
                            placeholder="Ex : 450 €"
                        />
                    </Conditionnal>
                </div>
                {/* affichage bouton suivant si prix achat rempli et si loyer remplis dans le cas d'un locatif*/}
                <Conditionnal linked_data_id="prj_montant_travaux" isNotEmpty>
                    <Conditionnal
                        linked_data_id="prj_usage"
                        isEqualTo
                        targetDataValueCompare="LOCATIF"
                    >
                        <Conditionnal
                            linked_data_id="prj_futur_loyer_estim"
                            isNotEmpty
                        >
                            <div className="SubmitButtonContainer">
                                {' '}
                                <Button text="Suivant" targetView={6} />{' '}
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="prj_usage"
                        isNotEqualTo
                        targetDataValueCompare="LOCATIF"
                    >
                        <div className="SubmitButtonContainer">
                            {' '}
                            <Button text="Suivant" targetView={6} />{' '}
                        </div>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>

            {/* SI PROJET TYPE SUR SCPI */}
            <Conditionnal
                linked_data_id="prj_type"
                isEqualTo
                targetDataValueCompare="ACHAT_SCPI"
            >
                <div className="Container">
                    <BlocIntField
                        key="key39"
                        nbcolumn={1}
                        linked_data_id="prj_montant_achat"
                        symbole=" €"
                        label="Prix d’achat"
                        placeholder="Ex : 10 000 €"
                        infobulle="Indiquez ici le prix TTC sauf si la TVA n’est pas à votre charge. Dans ce dernier car, veuillez indiquer le prix HT et ajuster manuellement les frais de notaire."
                        limit={1000000000}
                        messageErreur="Le montant du projet est trop élevé."
                    />
                    <BlocIntField
                        key="key40"
                        nbcolumn={1}
                        linked_data_id="prj_montant_frais_divers"
                        symbole=" €"
                        label="Frais divers"
                        placeholder="Ex : 10 000 €"
                        infobulle="Ex: Cuisine, aménagement, etc."
                    />
                    <Conditionnal
                        linked_data_id="prj_usage"
                        isEqualTo
                        targetDataValueCompare="LOCATIF"
                    >
                        <BlocIntField
                            key="key41"
                            nbcolumn={1}
                            linked_data_id="prj_futur_loyer_estim"
                            symbole=" €"
                            label="Futur loyer perçu estimé pour ce bien"
                            placeholder="Ex : 30 000 €"
                        />
                    </Conditionnal>
                </div>
                {/* affichage bouton suivant si prix achat rempli et si loyer remplis dans le cas d'un locatif*/}
                <Conditionnal linked_data_id="prj_montant_achat" isNotEmpty>
                    <Conditionnal
                        linked_data_id="prj_montant_achat_validated"
                        isEqualTo
                        targetDataValueCompare={true}
                    >
                        <Conditionnal
                            linked_data_id="prj_usage"
                            isEqualTo
                            targetDataValueCompare="LOCATIF"
                        >
                            <Conditionnal
                                linked_data_id="prj_futur_loyer_estim"
                                isNotEmpty
                            >
                                <div className="SubmitButtonContainer">
                                    {' '}
                                    <Button text="Suivant" targetView={6} />{' '}
                                </div>
                            </Conditionnal>
                        </Conditionnal>
                        <Conditionnal
                            linked_data_id="prj_usage"
                            isNotEqualTo
                            targetDataValueCompare="LOCATIF"
                        >
                            <div className="SubmitButtonContainer">
                                {' '}
                                <Button text="Suivant" targetView={6} />{' '}
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>
        </div>
    )
}
